/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsCareersListViewProps } from './hosports-careers-list';

export default (props: IHosportsCareersListViewProps) => {
    return (
        <h2>{'hosports-careers-list'}</h2>
    );
};
